import { skeletonStyles } from '@components/Skeleton'
import { analytics } from '@services/Analytics'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'
import { useRouter } from 'next/navigation'
import * as React from 'react'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import { SolitoImage } from 'solito/image'
import truncate from 'truncate'
import type { Story } from '../model/story'

type Props = Pick<Story, 'id' | 'title' | 'hero_image_path'>

export function StoryCard(props: Props) {
  const router = useRouter()
  const handleClick = () => {
    analytics.track('Story View', {
      storyTitle: props.title,
    })
    router.push(`/story/${props.id}`)
  }
  return (
    <Pressable style={styles.container} onPress={handleClick}>
      <View style={styles.image}>
        <SolitoImage
          src={props.hero_image_path}
          alt={props.title}
          priority
          height={150}
          width={267}
          contentFit="cover"
        />
      </View>

      <Text numberOfLines={1} style={styles.storyTitle}>
        {truncate(props.title, 20, { ellipsis: '...' })}
      </Text>
    </Pressable>
  )
}

function Loading() {
  return (
    <View style={styles.container}>
      <View style={[skeletonStyles.base, styles.image]} />
      <View style={{ padding: 16 }}>
        <View style={[skeletonStyles.base, { height: 24, width: 200 }]} />
      </View>
    </View>
  )
}

StoryCard.Loading = Loading

const styles = StyleSheet.create({
  container: {
    width: 267,
    marginRight: 16,
  },
  image: {
    width: 267,
    height: 150,
    borderRadius: 8,
    overflow: 'hidden',
  },
  storyTitle: {
    marginTop: 8,
    fontSize: Fonts.size.medium,
    fontWeight: 'bold',
    color: Colors.black,
  },
})
